import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { LOADING, IDLE, ERROR } from '../../../../store/selectors.ts';
import { FormGroup, Type, FormSelect } from '@spotify-internal/encore-creator-web';
import { trackEvent } from '../../../../lib/Tracking';
import { PodcastModalBody } from '../../../Shared/PodcastModal/index.tsx';

export class PodcastUpdateLicensor extends PureComponent {
  static propTypes = {
    currentLicensor: PropTypes.string,
    aggregators: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.name,
      }),
    ),
    suggestedNetworkId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    status: PropTypes.oneOf([LOADING, IDLE, ERROR]),
  };

  componentDidMount() {
    trackEvent({
      category: 'feed-update',
      action: 'licensor',
      label: 'start',
    });
  }

  render() {
    return (
      <Fragment>
        <PodcastModalBody data-qa="rss-verification-form">
          <Type as="h1" variant={Type.heading2}>
            {'Confirm your hosting provider'}
          </Type>
          <Type as="p">
            Selecting your hosting provider will ensure that you’ll see Spotify analytics on your
            host’s dashboard.
          </Type>
          <FormGroup label="Hosting provider" labelFor="podcastLicensor">
            <FormSelect
              id="podcastLicensor"
              data-testid="podcast-licensor"
              defaultValue={this.props.suggestedNetworkId}
              onChange={this.props.onChange}
              error={this.props.status === ERROR}
            >
              <option disabled value="">
                Choose one
              </option>
              {this.props.aggregators.map(l => (
                <option key={l.id} value={l.id}>
                  {l.name}
                </option>
              ))}
            </FormSelect>
          </FormGroup>
          {this.props.status === ERROR && (
            <Type as="p" data-testid="passthrough-failure" color={'failure'} variant={Type.sm}>
              This hosting provider has specific requirements that are not met by this RSS feed.
              <br />
              Please contact them for more details on what needs to be updated before making this
              change.
            </Type>
          )}
        </PodcastModalBody>
      </Fragment>
    );
  }
}
